
// This component is no longer used in the layout
const Navbar = () => {
  return null;
};

export default Navbar;
